import { dataProps } from './properties'

export const setTaskCategoryList = (state, payload) => {
    state.list = payload
}    

export const setTaskCategoryData = (state, payload) => {
    state.props = payload
} 

export const resetTaskCategoryData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/taskCategory/mutations.js